<div class="gallery-label bar controls">
  <span class="left controls">
    {{ 'core.selected' | translate }} {{ data.selected ?? 0 }}/{{ data.total ?? 0 }} ({{ 'label.total' | translate }}:
    {{ data.totalSelected ?? 0 }})
  </span>

  <span class="center controls">
    <b *ngIf="data.title"> {{ data.title | translate }}</b></span
  >

  <span class="right controls"></span>
</div>
